import { ProfileDto } from '@eventr/common'
import {
    MobileConfirmDialog,
    RequiredActionDialog,
    TermsNotAcceptedProps,
    useDialogStore,
} from '@eventr/common-storybook'
import { bs } from '../../state/bound.store'
import i18n from '../../i18n/i18next'

export const checkForTermsAndConditions = async (profile: ProfileDto) => {
    if (profile === undefined) {
        return
    }
    const h = TermsNotAcceptedProps.header

    if (profile.termsConditionsAcceptedUnix === 0) {
        useDialogStore.getState().replaceDialog({
            node: (
                <RequiredActionDialog
                    {...TermsNotAcceptedProps}
                    marketingOptIn={(profile.marketingAcceptedUnix ?? 0) > 0}
                    onConfirm={async () => {
                        await bs().updateRequest({ termsAccepted: true })
                        useDialogStore.getState().clearDialog()
                    }}
                    onCancel={async () => {
                        useDialogStore.getState().replaceDialog({
                            node: (
                                <MobileConfirmDialog
                                    text={i18n.t(
                                        'info-dialog.areYouSureYouWantToDecline'
                                    )}
                                    header={i18n.t(
                                        'info-dialog.declineTermsOfService'
                                    )}
                                    onCancel={() => {
                                        checkForTermsAndConditions(profile)
                                    }}
                                    onConfirm={() => {
                                        bs().logout()
                                        useDialogStore.getState().clearDialog()
                                    }}
                                    confirmText={i18n.t('info-dialog.decline')}
                                />
                            ),
                            backdropClosable: false,
                        })
                    }}
                    onMarketingOptInChange={(value) => {
                        bs().updateRequest({ marketingOptIn: value })
                    }}
                />
            ),
            backdropClosable: false,
        })
    }
}
